import { h } from 'preact'
export const IconClose = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 18 18"
            width="18px"
            height="18px"
        >
            <title>close</title>
            <path d="M9.70728,9L17.854,.85352c.19531-.19531,.19531-.51172,0-.70703s-.51172-.19531-.70703,0L9.00024,8.29297,.85352,.14648C.6582-.04883,.3418-.04883,.14648,.14648S-.04883,.6582,.14648,.85352L8.29321,9,.14648,17.14648c-.19531,.19531-.19531,.51172,0,.70703,.09766,.09766,.22559,.14648,.35352,.14648s.25586-.04883,.35352-.14648L9.00024,9.70703l8.14673,8.14648c.09766,.09766,.22559,.14648,.35352,.14648s.25586-.04883,.35352-.14648c.19531-.19531,.19531-.51172,0-.70703L9.70728,9Z" fill="currentColor"/>
        </svg>
    )
}
